// Web only, not mirrored: reads this app's `IUser` and the credential-service response.

import type { IUser } from '~/models';
import type { IOfficeMissingInfoSource } from '../types/OfficeMissingInfo';
import type { IOfficeCredentialsResponse } from '../types/OfficeMissingInfo.api';

/** The selected office's profile and credentials → the flat snapshot the missing-fields rule reads. */
export const toOfficeMissingInfoSource = (
  office: IUser,
  credentials: IOfficeCredentialsResponse,
): IOfficeMissingInfoSource => ({
  timePerPatientRDH: office.office_info?.timePerPatientRDH,
  timePerPatientDA: office.office_info?.timePerPatientDA,
  timePerPatientDN: office.office_info?.timePerPatientDN,
  isAssistedHygiene: office.office_info?.isAssistedHygiene,
  // Parking lives at the user root, not under office_info.
  parkingInformation: office.parkingInformation,
  operatories: office.office_info?.productivity?.operatories,
  softwares: credentials.education?.softwares,
  insurances: credentials.insurances,
  specialtyKeys: Object.keys(credentials.education?.specialtiesAndProcedures ?? {}),
});
